import React, {useEffect} from "react";
import Container from 'react-bootstrap/Container';
import '../lg/Lg.css';
import {appdata} from "../../logic_tmp/appdata/AppData";
import {logPageOpened} from "../model/utils";
import {TildaB} from "../lg/widgets/common/TildaB";
import {lgSetup} from "../../backend/LgSetup";
import {sendHeight} from "../../resizer";

export function LrrhHeader() {
    let lm = lgSetup.lms[appdata.lmKey]
    let bannerImage = "/cfg/" + lm["bannerResource"]
    appdata.viewType = "LeadMagnetPage"
    useEffect(() => {
        logPageOpened(appdata.parentPath,appdata.viewType)
    }, []);
    return (<div>

        <Container>
            <TildaB>
                <img className="fit-picture" src="/cfg/LRRH/Images/HeaderBanner.jpg" onLoad={()=>sendHeight("IMGBanner")}
                     alt="Grapefruit slice atop a pile of other slices" />
            </TildaB><TildaB>
                <span className="normal">{lm.desc}</span>
            </TildaB>
            <TildaB>
                <img className="fit-picture" src={bannerImage} onLoad={()=>sendHeight("IMGLogo")}
                     alt="Grapefruit slice atop a pile of other slices" width="100%"/>
            </TildaB>
            <TildaB>
                <span className="normal">Внимание! Эта страничка содержит тексты и картинки сгенерированные искусственным интеллектом.</span>
            </TildaB>
        </Container>
    </div>);
}

